<div class="p-6 rounded-md w-full items-center align-middle bg-[var(--colorGrey)]">
    <!-- Title -->
    <p class="text-sm font-bold mb-1 truncate text-[var(--color-text-strong)]">{{ title() }}</p>

    <!-- Subtitle -->
    <p class="mb-4 text-sm text-[rgb(var(--ui-5))] truncate">{{ subtitle() }}</p>

    <!-- Valuea -->
    <h1 class="font-bold" [class.text-[rgb(var(--ui-2))]]="ammountShouldBeGreen()">
        {{ currency() ? (amount() | customCurrency) : amount() }}
    </h1>
</div>
